











import { InjectReactive, Prop, Vue, Component } from 'vue-property-decorator'

@Component
export default class TabLink extends Vue {
    @Prop({ required: true }) readonly name!: string
    @Prop() readonly title!: string
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
    @InjectReactive() readonly activeTab!: string

    async setActive(): Promise<void> {
        if (this.disabled || this.activeTab === this.name) {
            return
        }

        this.$parent.$parent.$emit('activate', this.name)
    }

    get isActive(): boolean {
        return this.activeTab === this.name
    }

    get componentClass(): object {
        return {
            'tab-link': true,
            'tab-link--active': this.isActive,
            'tab-link--disabled': this.disabled,
        }
    }
}
